module.exports = __webpack_public_path__ + "img/img4.a24f6bc2.png";